document.addEventListener("turbo:load", () => {
  const links = document.querySelectorAll("button[data-hour-select]");
  links.forEach(element => {
    element.addEventListener("click", event => {
      event.preventDefault();
      const entry = element.dataset;
      scrollToHour(entry);
    });
  });
});



function scrollToHour(entry) {
  var logContainer = document.getElementById("log-container");
  var entryContainer = document.getElementById(
    entry.hourSelect.padStart(2, "0").padEnd(6, "0")
  );
  entryContainer.className += " active";
  var entryContainerOffset = entryContainer.offsetTop;
  logContainer.scrollTo({
    top: entryContainerOffset - 116,
    behavior: "smooth"
  });
}

function scrollToTrack(entry) {
  var logContainer = document.getElementById("log-container");
  var entryContainer = document.getElementById(entry.description);
  
  // Add null checks to prevent errors
  if (!logContainer || !entryContainer) {
    console.warn('Missing DOM elements for scrollToTrack:', {
      logContainer: !!logContainer,
      entryContainer: !!entryContainer,
      entry: entry
    });
    return;
  }
  
  entryContainer.className += " active";
  var entryContainerOffset = entryContainer.offsetTop;
  logContainer.scrollTo({
    top: entryContainerOffset - 50,
    behavior: "smooth"
  });
}

function clearActiveTrack(elems) {
  [].forEach.call(elems, function(el) {
    el.children[0].classList.remove("active");
  });
}

function clearActiveLogItem(elems) {
  [].forEach.call(elems, function(el) {
    el.classList.remove("active");
  });
}

function clearData() {
  $("#track-header-content").empty();
  $("#track-script-content").empty();
  $("#record-elements").empty();
  $("#header-loading").show();
  $("#script-loading").show();
  $("#record-loading").show();
  $('#record-elements').hide();
}

document.addEventListener("turbo:load", () => {
  const links = document.querySelectorAll("a[data-track-select]");
  links.forEach(element => {
    element.addEventListener("click", event => {
      clearData();
      var childDivs = document
        .getElementById("log-container")
        .getElementsByTagName("div");
      clearActiveLogItem(childDivs);

      var elems = document.querySelectorAll("a[data-track-select]");
      clearActiveTrack(elems);

      var elems = document.querySelectorAll("log-container");

      event.preventDefault();
      const kids = element.children;
      kids[0].className += " active";
      const entry = element.dataset;
      scrollToTrack(entry);
    });
  });
});
